<template>
  <div class="container-fluid mb-4 gs-header-filters">
    <b-button
        class="header-filter-btns"
        :class="isActive('all') ? 'active' : ''"
        variant="theme"
        @click="activateTab('all')"
    >
        All
        <i class="fas text-primary fa-layer-group fa-fw float-right"></i>
    </b-button>
    <b-button
        class="ml-2 header-filter-btns"
        :class="isActive('departments') ? 'active' : ''"
        variant="theme"
        @click="activateTab('departments')"
    >
        Departments
        <i class="fas text-primary fa-project-diagram fa-fw float-right"></i>
    </b-button>
    <b-button
        class="ml-2 header-filter-btns"
        :class="isActive('contacts') ? 'active' : ''"
        variant="theme"
        @click="activateTab('contacts')"
    >
        Contacts
        <i class="far text-primary fa-id-badge fa-fw float-right"></i>
    </b-button>
    <b-button
        class="ml-2 header-filter-btns"
        :class="isActive('coordinators') ? 'active' : ''"
        variant="theme"
        @click="activateTab('coordinators')"
    >
        Users
        <i class="far text-primary fa-user-circle fa-fw float-right"></i>
    </b-button>
    <b-button
        class="ml-2 header-filter-btns"
        :class="isActive('tags') ? 'active' : ''"
        variant="theme"
        @click="activateTab('tags')"
    >
        Tags
        <i class="fas text-primary fa-hashtag fa-fw float-right"></i>
    </b-button>
  </div>
</template>

<script>
export default {
    props: [
        'currentTab'
    ],
    methods: {
        activateTab(activeTab) {
            this.$emit('click', activeTab);
        },
        isActive(tab) {
            return this.currentTab === tab;
        }
    }
}
</script>

<style>

</style>